import React from 'react';
import LoginCont from '../../containers/Login/Login.cont';

export default function () {
  return <LoginCont />;
}
